<!--
  ConfidenceBadge Component
  Color-coded badge based on confidence score.
  Green (>80%), Orange (50-80%), Red (<50%)
  Shows "manuell"/"Manual" when isManual is true.
-->
<script lang="ts">
  import { _ } from 'svelte-i18n';

  export let score: number;
  export let showPercent = true;
  export let isManualClassified = false;

  $: pct = score <= 1 ? score * 100 : score;
  $: variant = isManualClassified
    ? 'info'
    : pct >= 80
      ? 'success'
      : pct >= 50
        ? 'warning'
        : 'error';
  $: label = isManualClassified
    ? $_('components.confidence_badge.manual')
    : showPercent
      ? `${Math.round(pct)}%`
      : '';

  const variantClasses: Record<string, string> = {
    success: 'bg-success/15 text-success border-success/30',
    warning: 'bg-warning/15 text-warning border-warning/30',
    error: 'bg-error/15 text-error border-error/30',
    info: 'bg-primary/15 text-primary border-primary/30',
  };
</script>

<span
  class="inline-flex items-center gap-1 px-2 h-6 text-xs font-medium rounded-full border {variantClasses[
    variant
  ]}"
>
  <span class="w-1.5 h-1.5 rounded-full bg-current"></span>
  {#if label}{label}{/if}
  <slot />
</span>
